import { POST_API } from "../../Functionalities/APIs";

export const ManageNotification = async (e, data, keyword, params) => {
    let path = "/notifications/";
    if (keyword == 'add') {
        var fdata = new FormData()
        if (data.keyword === "item_offer") {
            // void 0
            fdata.append('keyword', 'item_offer');
            fdata.append('item_off_id', data.item_off_id);
        }
        if (data.keyword === "branch_discount") {
            fdata.append('keyword', 'branch_discount');
            fdata.append('branch_off_id', data.branch_off_id);
        }
        if (data.keyword === "item") {
            fdata.append('keyword', 'item');
            fdata.append('item_id', data.item_id);
        }
        if (data.keyword === "branch") {
            fdata.append('keyword', 'branch');
            fdata.append('branch_id', data.branch_id);
        }
        fdata.append("notification", data.message)
        fdata.append("title", data.title)
        fdata.append("user_list", '[]')

        const target = data.target || "customers";
        fdata.append("target", target);
        if (target === "delivery_boys") {
            // An announcement has to reach riders who are off duty too; the
            // backend defaults this to false and would skip them.
            fdata.append("include_off_duty", data.include_off_duty ? "true" : "false");
        }
        if (data.franchise_id) {
            fdata.append("franchise_id", data.franchise_id);
        }
        if (data.image) {
            fdata.append('image', data.image);
        }
        let result = POST_API(fdata, '', path)
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}
